import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherSchedule/Load',
      params,
    });
  },
  SelectWorkData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherSchedule/SelectWorkData',
      params,
    });
  },
  SelectWorkMinData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherSchedule/SelectWorkMinData',
      params,
    });
  },
  LoadModifyRecord(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherSchedule/LoadModifyRecord',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherSchedule/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherSchedule/Add',
      data,
      transformResponse: [(res) => {
        const { code, message } = JSON.parse(res);
        let obj = {};
        if (code === 500) {
          const regex = /:|：|;/gm;
          const msgArr = message.replace(regex, '<br>');
          obj = { code, message: msgArr };
        }
        if (code === 200) {
          obj = JSON.parse(res);
        }
        return obj;
      }],
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherSchedule/Update',
      data,
      transformResponse: [(res) => {
        const { code, message } = JSON.parse(res);
        let obj = {};
        if (code === 500) {
          const regex = /:|：|;/gm;
          const msgArr = message.replace(regex, '<br>');
          obj = { code, message: msgArr };
        }
        if (code === 200) {
          obj = JSON.parse(res);
        }
        return obj;
      }],
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      url: 's7x_TeacherSchedule/Delete',
      data,
    });
  },
};
